// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607160508/js/" + chunkId + "." + {"44":"d9f8f034","225":"3cbd7675","481":"86e3ac45","486":"3d4b2e2e","770":"7a590968"}[chunkId] + ".0.4179199430484303.chunk.js";
};